import React, { useState } from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import SelectComponent from "./SelectComponent";
import datos from "../data/geojson/json/generatedConfig.json";
import iconObras from "../assets/icon-obras.png";
import iconProyecto from "../assets/icono-elproyecto.png";
import iconAsistencia from "../assets/icono-asistenciatecnica.png";

const BuscarPanel = ({ isOpen, onToggle, onSearchChange, activeTab, onFiltersChange }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState([]);
  const [marketSearch, setMarketSearch] = useState("");
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const categories = {
    obras: {
      color: "#b71c1c",
      subitems: {
        "ejecutadas": (item) => item.etapa === "EJECUCIÓN FÍSICA" && item.estado_ef === "En ejecución",
        "en ejecucion": (item) => item.etapa === "EJECUCIÓN FÍSICA",
        "monitoreo (ejecucion GL)": (item) => item.estado_ef === "En ejecución",
        "ioarr": (item) => item.modalidad === "IOARR"
      }
    },
    proyecto: {
      color: "#4caf50",
      subitems: {
        "expediente tecnico": (item) => item.etapa === "ELABORACIÓN DE EXPEDIENTE",
        "perfil": (item) => item.etapa === "PRE INVERSIÓN",
        "ioarr": (item) => item.modalidad === "IOARR"
      }
    },
    asistencia: {
      color: "#ff9800",
      subitems: {
        "expediente tecnico": (item) => item.etapa === "ELABORACIÓN DE EXPEDIENTE",
        "perfil": (item) => item.etapa === "PRE INVERSIÓN"
      }
    }
  };

  const departmentOptions = datos.parquesIndustriales.departamento;

  const provinceOptions = datos.parquesIndustriales.provincia

  const districtOptions = datos.parquesIndustriales.distrito;

  const handleSearch = async () => {
    try {
      let dataModule;

      switch (activeTab) {
        case 0: // Minoristas
          dataModule = await import("../data/intervenciones_real_minorista");
          break;
        case 1: // Mayoristas
          dataModule = await import("../data/intervenciones_real_mayorista");
          break;
        case 2: // Parques industriales
          dataModule = await import("../data/parques_industriales");
          break;
        case 3: // Zonas industriales
          dataModule = await import("../data/zonas_industriales");
          break;
        default:
          dataModule = await import("../data/intervenciones_real_minorista");
      }

      const data = dataModule.default || dataModule;

      const filteredData = data.filter((item) => {
        if (searchTerm && !item.nombre?.toLowerCase().includes(searchTerm.toLowerCase())) {
          return false;
        }

        if (selectedDepartment.length > 0 && !selectedDepartment.includes(item.departamento_id)) {
          return false;
        }

        if (selectedProvince.length > 0 && !selectedProvince.includes(item.provincia_id)) {
          return false;
        }

        if (selectedDistrict.length > 0 && !selectedDistrict.includes(item.distrito_id)) {
          return false;
        }

        if (marketSearch && !item.nombre?.toLowerCase().includes(marketSearch.toLowerCase())) {
          return false;
        }

        // Apply category filters only for mayoristas (activeTab 1)
        if (activeTab === 1 && selectedFilters.length > 0) {
          const matchesFilter = selectedFilters.some(filterKey => {
            for (const category of Object.values(categories)) {
              if (category.subitems[filterKey] && category.subitems[filterKey](item)) {
                return true;
              }
            }
            return false;
          });
          if (!matchesFilter) {
            return false;
          }
        }

        return true;
      });

      onSearchChange(filteredData);
      onFiltersChange(selectedFilters);
    } catch (error) {
      console.error("Error al realizar búsqueda:", error);
    }
  };

  const handleClear = () => {
    setSearchTerm("");
    setSelectedDepartment([]);
    setSelectedProvince([]);
    setSelectedDistrict([]);
    setMarketSearch("");
    setSelectedFilters([]);
    setExpandedCategory(null);
  };

  const handleFilterChange = (filterKey) => {
    setSelectedFilters(prev =>
      prev.includes(filterKey)
        ? prev.filter(f => f !== filterKey)
        : [...prev, filterKey]
    );
  };

  return (
    <div
      style={{
        position: "absolute",
        top: "110px",
        left: 0,
        height: "calc(100% - 110px)",
        zIndex: isOpen ? 100 : 90,
        pointerEvents: isOpen ? "auto" : "none",
      }}
    >
      <div
        onClick={onToggle}
        title={isOpen ? "Cerrar Búsqueda" : "Buscar"}
        style={{
          position: "absolute",
          top: "55%",
          left: isOpen ? "300px" : 0,
          transform: "translateY(-50%)",
          width: "40px",
          height: "40px",
          background: "rgba(0, 0, 0, 0.4)",
          backdropFilter: "blur(8px)",
          borderRadius: "0 8px 8px 0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          pointerEvents: "auto",
          transition: "left 0.3s ease",
        }}
      >
        {isOpen ? <FaTimes color="#fff" /> : <FaSearch color="#fff" />}
      </div>

      {/* Panel lateral de búsqueda */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: isOpen ? 0 : "-300px",
          width: "300px",
          height: "100%",
          background: "rgba(0,0,0,0.3)",
          backdropFilter: "blur(8px)",
          borderRight: "1px solid rgba(255,255,255,0.2)",
          boxShadow: "rgba(0, 0, 0, 0.2) 5px 0 5px",
          padding: "15px",
          transition: "left 0.3s ease, opacity 0.3s ease",
          opacity: isOpen ? 1 : 0,
          pointerEvents: isOpen ? "auto" : "none",
          overflowY: "auto",
          color: "#fff",
        }}
      >
        <h3 style={{ marginBottom: "20px", textAlign: "center" }}>Buscar</h3>

        {/* Campo de búsqueda general */}
        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px", fontSize: "14px" }}>
            Buscar
          </label>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Ingrese término de búsqueda..."
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid rgba(255,255,255,0.3)",
              borderRadius: "4px",
              background: "rgba(255,255,255,0.1)",
              color: "#fff",
            }}
          />
        </div>

        {/* Selector de Departamento */}
        <div style={{ marginBottom: "15px" }}>
          <SelectComponent
            label="Departamento"
            value={selectedDepartment}
            onChange={setSelectedDepartment}
            options={departmentOptions}
            multiple={false}
            placeholder="Seleccione departamento"
          />
        </div>

        {/* Selector de Provincia */}
        <div style={{ marginBottom: "15px" }}>
          <SelectComponent
            label="Provincia"
            value={selectedProvince}
            onChange={setSelectedProvince}
            options={provinceOptions}
            multiple={false}
            placeholder="Seleccione provincia"
          />
        </div>

        {/* Selector de Distrito */}
        <div style={{ marginBottom: "15px" }}>
          <SelectComponent
            label="Distrito"
            value={selectedDistrict}
            onChange={setSelectedDistrict}
            options={districtOptions}
            multiple={false}
            placeholder="Seleccione distrito"
          />
        </div>

        {/* Botones de búsqueda */}
        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "10px", fontSize: "14px" }}>
            Tipo de Búsqueda
          </label>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {Object.entries(categories).map(([key, category]) => (
              <div key={key}>
                <button
                  onClick={() => setExpandedCategory(expandedCategory === key ? null : key)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    backgroundColor: category.color,
                    color: "#fff",
                    padding: "10px 12px",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <img
                      src={key === "obras" ? iconObras : key === "proyecto" ? iconProyecto : iconAsistencia}
                      alt={key}
                      style={{ width: "20px", height: "20px" }}
                    />
                    {key === "obras" ? "OBRAS" : key === "proyecto" ? "EN PROYECTO" : "ASISTENCIA TÉCNICA"}
                  </div>
                  <span>{expandedCategory === key ? "−" : "+"}</span>
                </button>
                {expandedCategory === key && (
                  <div style={{ marginTop: "10px", paddingLeft: "20px" }}>
                    {Object.keys(category.subitems).map((subitem) => (
                      <label key={subitem} style={{ display: "block", marginBottom: "5px", fontSize: "12px" }}>
                        <input
                          type="checkbox"
                          checked={selectedFilters.includes(subitem)}
                          onChange={() => handleFilterChange(subitem)}
                          style={{ marginRight: "5px" }}
                        />
                        {subitem}
                      </label>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Botones de acción */}
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={handleSearch}
            style={{
              backgroundColor: "#b71c1c",
              color: "#fff",
              padding: "8px 12px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              flex: 1,
            }}
          >
            Buscar
          </button>
          <button
            onClick={handleClear}
            style={{
              backgroundColor: "#666",
              color: "#fff",
              padding: "8px 12px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              flex: 1,
            }}
          >
            Limpiar
          </button>
        </div>
      </div>
    </div>
  );
};

export default BuscarPanel;
